import { Card, Stack, Typography } from '@mui/material';
import { RevaAskChip } from '../../components/Reva';
import { transactionsWithIncludes } from '../../store/slices/transactions';
// eslint-disable-next-line max-len
import TransactionProgressBar from '../../components/TransactionProgressBar/TransactionProgressBar';
import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from '../../store/store';
import { selectStatusByListingId } from '../../store/selectors/status';
import { fetchStatus } from '../../store/slices/status';
import { useEffect } from 'react';
import useIsMobile from '../../hooks/useIsMobile';
import { listings, ListingType, UserType } from '@prisma/client';
import { ChevronRight } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import ClosingDate from '../../components/ClosingDate/ClosingDate';
import RepairRequest from './components/RepairRequest';
import { useAuth } from '../../contexts/AuthContext';

interface Props {
  listing: listings;
  transaction?: transactionsWithIncludes;
  borderless?: boolean;
}

const TransactionJourney: React.FC<Props> = ({
  listing,
  transaction,
  borderless = false,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const status = useSelector((state: RootState) =>
    selectStatusByListingId(state, listing.id)
  );
  const { currentUser } = useAuth();
  const isPBuyer = currentUser?.type === UserType.PBUYER;
  const isBuyer = listing.type === ListingType.BUYER;

  useEffect(() => {
    dispatch(fetchStatus(listing.id));
  }, [listing.id]);

  if (
    listing.status === 'PENDING' ||
    (listing.status === 'DRAFT' && !isBuyer)
  ) {
    return null;
  }

  if (isPBuyer && !transaction) {
    return null;
  }

  const getTitleText = () => {
    if (isPBuyer) {
      return 'Transaction Status';
    }
    if (isBuyer) {
      return 'Buying Journey';
    }
    return 'Selling Journey';
  };

  return (
    <Card elevation={borderless ? 0 : 1}>
      {transaction && status && (
        <RepairRequest transaction={transaction} status={status} />
      )}
      <Stack
        direction="column"
        spacing={2}
        pt={2}
        pb={isMobile ? 0 : 2}
        onClick={() => {
          if (transaction) {
            navigate(`/transactions/${transaction.id}`);
          }
        }}
        sx={{ cursor: transaction ? 'pointer' : 'default' }}
      >
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="h6" fontWeight={600}>
              {getTitleText()}
            </Typography>
            {transaction && isBuyer && (
              <RevaAskChip
                question={`What's next for my purchase of ${listing.address}, and what should I be doing right now?`}
              />
            )}
          </Stack>
          {transaction && (
            <Stack direction="row" alignItems="center">
              <ClosingDate transaction={transaction} />
              {!isMobile && <ChevronRight />}
            </Stack>
          )}
        </Stack>
        {status && (
          <TransactionProgressBar
            status={status}
            isBuyer={isBuyer}
            onViewAllSteps={() => {
              navigate(`/transactions/${transaction?.id}`);
            }}
          />
        )}
      </Stack>
    </Card>
  );
};

export default TransactionJourney;
